export const PAYMENT_ACTIVITY_TABS_ID = {
  INVOICE_TAB_ID: 'Invoice',
  EMAIL_TAB_ID: 'Email',
  HISTORY_TAB_ID: 'History',
}
